import { useTranslation } from 'react-i18next'

import { NOTIFICATION_TYPE } from '../../../constants/common'
import { CalendarGrid } from '../../CalendarGrid'
import { NotificationInline } from '../../Notification'
import { CALENDAR_TASKS_FILTERS } from '../Calendar.constants'
import { CalendarContext } from '../Calendar.context'
import { CalendarDayPopoverActions } from '../CalendarDayPopoverActions'
import { CalendarItemStatus } from '../CalendarItemStatus'

import { QA_NAME_CALENDAR_NO_TASK_TYPES } from './CalendarView.constants'
import { useCalendarView } from './CalendarView.hooks'
import {
  getCalendarViewBodyMessage,
  getHasCalendarViewNoTaskTypesNotice,
} from './CalendarView.utils'

import * as styles from './CalendarView.module.css'

function CalendarView({
  className = styles.CalendarView,
  filters = CALENDAR_TASKS_FILTERS,
  initialMode,
  modes,
  onChangeMode,
}) {
  const { t } = useTranslation()

  const {
    calendar,
    handleClickItem,
    handleMoveItem,
    handleOpenRelieveDay,
    handleStartAction,
    modal,
  } = useCalendarView({ filters, initialMode, modes, onChangeMode })

  return (
    <CalendarContext value={{ onOpenRelieveDay: handleOpenRelieveDay }}>
      <div className={className} onClickCapture={handleStartAction}>
        {getHasCalendarViewNoTaskTypesNotice({ calendar, filters }) ? (
          <NotificationInline
            qaName={QA_NAME_CALENDAR_NO_TASK_TYPES}
            text={t('Calendar.EmptyNoTaskTypesKey')}
            type={NOTIFICATION_TYPE.info}
          />
        ) : null}
        <CalendarGrid
          DayPopoverActions={CalendarDayPopoverActions}
          ItemStatus={CalendarItemStatus}
          bodyMessage={getCalendarViewBodyMessage({ calendar, filters, t })}
          calendar={calendar}
          isLoading={calendar.isLoading || calendar.isRefetching}
          onClickItem={handleClickItem}
          onMoveItem={handleMoveItem}
        />
      </div>
      {modal}
    </CalendarContext>
  )
}

export default CalendarView
